import { PermModule } from '@playq/octopus2-auth';

import type { IMenuItemBase } from './types';

export const corpMenuStructure: IMenuItemBase[] = [
  {
    id: 'users',
    module: PermModule.None,
    label: 'Users',
    route: '/corp/users',
  },
  {
    id: 'groups',
    module: PermModule.None,
    label: 'Groups',
    route: '/corp/groups',
  },
  {
    id: 'permissions',
    module: PermModule.None,
    label: 'Permissions',
    route: '/corp/permissions',
  },
  {
    id: 'permissions2',
    module: PermModule.None,
    label: 'Permissions2',
    route: '/corp/permissions2',
  },
  {
    id: 'credentials',
    module: PermModule.CredentialsManagement,
    label: 'Credentials',
    route: '/corp/credentials',
    divider: true,
  },
  {
    group: 'Policies',
    id: 'assets-policy',
    module: PermModule.AssetsPolicyConfiguration,
    label: 'Creative Assets',
    route: '/corp/assets-policy',
  },
  {
    id: 'inventory-policy',
    module: PermModule.InventoryPolicyConfiguration,
    label: 'Inventory',
    route: '/corp/inventory-policy',
  },
  {
    id: 'packages-policy',
    module: PermModule.PackagesPolicyConfiguration,
    label: 'Packages',
    route: '/corp/packages-policy',
  },
  {
    id: 'experiments-policy',
    module: PermModule.ExperimentsPolicyConfiguration,
    label: 'Experiments',
    route: '/corp/experiments-policy',
    divider: true,
  },
  {
    group: 'AdHawk',
    id: 'integrations',
    module: PermModule.Integrations,
    label: 'Integrations',
    route: '/corp/integrations',
  },
  {
    id: 'integrations-webhooks',
    module: PermModule.Integrations,
    label: 'WebHooks',
    route: '/corp/integrations-webhooks',
    divider: true,
  },
  {
    id: 'tags-manager',
    module: PermModule.TagsManagement,
    label: 'Tags Manager',
    route: '/corp/tags-manager',
  },
  {
    id: 'webevents',
    module: PermModule.WebEventsConfiguration,
    label: 'WebEvents',
    route: '/corp/webevents',
  },
  {
    id: 'billing',
    module: PermModule.None,
    label: 'Billing',
    route: '/corp/billing',
  },
  {
    id: 'logs',
    module: PermModule.Logs,
    label: 'Logs',
    route: '/corp/logs',
  },
];
